<template>
  <div id="Dealings">
    <el-table
      ref="tableRef"
      :data="TableDt"
      border
      highlight-current-row
      @row-dblclick="invalidRow"
      @header-dragend="headerdragend"
      :summary-method="getSummaries"
      :show-summary="showsummary"
      style="width: 100%"
      class="tabone_sty"
      height="522px"
      :header-cell-style="{background:'#eef1f6',color:'#000',fontSize:'14px',height:'37px',padding:'0',fontWeight: 'bold'}"
    >
      <el-table-column width="80" height="500" align="center" prop="BarCode" fixed="left">
        <template slot="header">
          <i
            :class="isInner==true?'el-icon-s-tools':'el-icon-refresh-left'"
            @click="clickIcon"
            style="color:#2594ff;font-size:18px"
          ></i>
        </template>
        <template slot-scope="scope">{{scope.$index +1 }}</template>
      </el-table-column>
      <el-table-column fixed="left" align="center" label="对账标记" width="100">
        <template slot-scope="scope">
          <el-checkbox
            @change="changeclick(scope.row.DzFlag,scope.row)"
            :value="scope.row.DzFlag==2?true:false"
          ></el-checkbox>
        </template>
      </el-table-column>
      <template v-for="(item,index) in ObtainHeader">
        <el-table-column
          :label="item.Rename"
          align="center"
          :width="item.Width==''?'180':item.Width"
          v-if="item.Key == 'Number' && item.Show == true"
          :key="index"
        >
          <template slot-scope="scope">
            <el-button
              @click="invalidRow(scope.row)"
              type="text"
              size="small"
              :style="{color:scope.row.RedOld=='T'?'red':''}"
            >{{scope.row[item.Key]}}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          :label="item.Rename"
          :prop="item.Key"
          :width="item.Width==''?'200':item.Width"
          align="center"
          v-else-if="(item.Key != 'Number') && item.Show == true"
          :key="index"
        >
          <template slot-scope="scope">
            <input
              v-if="item.Key === 'InvoicedTotal'"
              ref="Invoic"
              :id="'x_'+scope.$index+'_y_'+index"
              size="mini"
              type="text"
              autocomplete="off"
              class="input_sty3"
              :style="{color:scope.row.RedOld=='T'?'red':''}"
              v-model="scope.row[item.Key]"
              @blur="changeData(scope.row,scope.$index,index)"
              @keyup.enter="EnterArrow($event,scope.row,scope.$index,index,)"
              @focus="doFocu($event)"
              @change.stop="scope.row[item.Key]=scope.row[item.Key].replace(/^\D*(\d*(?:\.\d{0,6})?).*$/g, '$1')"
            />
            <span
              v-else
              class="span_inner_sty"
              :style="{color:scope.row.RedOld=='T'?'red':''}"
            >{{scope.row[item.Key]}}</span>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      @size-click="handleSizeChange"
      @current-change="handleCurrentChange"
      @size-change="sizechange"
      :current-page="currentPages"
      :page-sizes="[10, 20,50,100]"
      :page-size="pagesizes"
      layout="total, sizes,prev, pager, next, jumper"
      :total="totals"
    ></el-pagination>
  </div>
</template>

<script>
const pageList = [
  { pageName: "销售订单", menuId: "3-1", pageRoute: "saleorder", VchType: 8 },
  {
    pageName: "销售出库单",
    menuId: "3-2",
    pageRoute: "salesrelease",
    VchType: 11,
  },
  {
    pageName: "销售退货单",
    menuId: "3-3",
    pageRoute: "salereturn",
    VchType: 45,
  },
  {
    pageName: "销售换货单",
    menuId: "3-4",
    pageRoute: "saleexchange",
    VchType: 142,
  },
  {
    pageName: "采购订单",
    menuId: "3-5",
    pageRoute: "procurementorder",
    VchType: 7,
  },
  {
    pageName: "采购入库单",
    menuId: "3-6",
    pageRoute: "procurementsrelease",
    VchType: 34,
  },
  {
    pageName: "采购退货单",
    menuId: "3-7",
    pageRoute: "procurementreturn",
    VchType: 6,
  },
  {
    pageName: "其他入库单",
    menuId: "3-8",
    pageRoute: "otherreceipt",
    VchType: 126,
  },
  {
    pageName: "其他出库单",
    menuId: "3-9",
    pageRoute: "outofstock",
    VchType: 139,
  },
  { pageName: "报损单", menuId: "3-10", pageRoute: "reportloss", VchType: 9 },
  { pageName: "报溢单", menuId: "3-11", pageRoute: "newspaper", VchType: 14 },
  {
    pageName: "调拨出库单",
    menuId: "3-12",
    pageRoute: "transfer",
    VchType: 21,
  },
  {
    pageName: "调拨入库单",
    menuId: "3-13",
    pageRoute: "transferlaid",
    VchType: 22,
  },
  { pageName: "调价单", menuId: "3-14", pageRoute: "modifyprice", VchType: 57 },
  { pageName: "收款单", menuId: "3-15", pageRoute: "voucherorder", VchType: 4 },
  {
    pageName: "付款单",
    menuId: "3-16",
    pageRoute: "paymentorder",
    VchType: 66,
  },
  {
    pageName: "增加应收",
    menuId: "3-17",
    pageRoute: "increaseaccounts",
    VchType: 116,
  },
  {
    pageName: "减少应收",
    menuId: "3-18",
    pageRoute: "reduceaccounts",
    VchType: 115,
  },
  {
    pageName: "增加应付",
    menuId: "3-19",
    pageRoute: "increasedcope",
    VchType: 128,
  },
  {
    pageName: "减少应收",
    menuId: "3-20",
    pageRoute: "reducecope",
    VchType: 129,
  },
  {
    pageName: "一般收入单",
    menuId: "3-21",
    pageRoute: "generalrevenue",
    VchType: 93,
  },
  {
    pageName: "一般费用单",
    menuId: "3-22",
    pageRoute: "generalcost",
    VchType: 36,
  },
  {
    pageName: "现金费用单",
    menuId: "3-23",
    pageRoute: "cashstatement",
    VchType: 35,
  },
  {
    pageName: "资金流向单",
    menuId: "3-24",
    pageRoute: "moneyflows",
    VchType: 77,
  },
];
import tool from "@/utils/tool.js";
export default {
  data() {
    return {
      tableData: this.TableDt,
      multipleSelection: [],
      isInners: this.isInner,
      currentPage: this.currentPages, //当前页码
      total: this.totals, //总页数
      pageSize: this.pagesizes, //每页显示数量
      taDataObtain: this.ObtainHeader,
      showsummary: this.ShowSummary,
      item: {
        component: "",
        menuId: "",
        query: {},
        title: "",
      },
    };
  },
  props: {
    isInner: Boolean,
    currentPages: Number,
    totals: Number,
    pagesizes: Number,
    TableDt: Array,
    ShowSummary: {
      type: Boolean,
      default: true,
    },
    ObtainHeader: Array,
  },
  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        const values = data.map((item) => {
          // if (
          //   column.property == "AQty" ||
          //   column.property == "ATotal" ||
          //   column.property == "AddComment" ||
          //   column.property == "AlreadyPaidTotal" ||
          //   column.property == "Date" ||
          //   column.property == "DecreaseTotal" ||
          //   column.property == "DiscountTotal" ||
          //   column.property == "GZDate" ||
          //   column.property == "IncreaseTotal" ||
          //   column.property == "InvoicedTotal" ||
          //   column.property == "NoInvoiceTotal" ||
          //   column.property == "NoPaidTotal" ||
          //   column.property == "LastTotal" ||
          //   column.property == "Number" ||
          //   column.property == "Settled" ||
          //   column.property == "Summary" ||
          //   column.property == "Total" ||
          //   column.property == "VchTypeName"
          // ) {
          // console.log(Number(item[column.property]));
          if (Number(item[column.property]) != "undefined") {
            return this.$attrs.footerMet[column.property]; //Number(item[column.property]);
          }
          // }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = this.$attrs.footerMet[column.property]; //this.sum(values);
          sums[index] += "";
        }
      });

      return sums;
    },
    changeData(data, rowindex, index) {
      this.$emit("InvoicedTotaldata", data);
    },
    distinctObj(numberArr, ind) {
      let obj = "";
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    EnterArrow(event, row, rowindex, index) {
      //
      for (let i = index + 1; i < this.ObtainHeader.length + 1; i++) {
        if (
          this.distinctObj(this.$refs.Invoic, `x_${rowindex}y_${i}`) !== false
        ) {
          this.distinctObj(this.$refs.Invoic, `x_${rowindex}y_${i}`).focus();
          return;
        }

        if (i + 1 == this.ObtainHeader.length + 1) {
          rowindex = rowindex + 1;
          for (let j = 1; j < this.ObtainHeader.length + 1; j++) {
            if (
              this.distinctObj(this.$refs.Invoic, `x_${rowindex}y_${j}`) !==
              false
            ) {
              this.distinctObj(
                this.$refs.Invoic,
                `x_${rowindex}y_${j}`
              ).focus();
              return;
            }
          }
        }
      }
    },
    doFocu(event) {
      event.currentTarget.select();
    },
    distinctObj(numberArr, ind) {
      let obj = [];
      for (var i of numberArr) {
        if (i.id == ind) {
          obj = i;
          return obj;
        }
      }
      return false;
    },
    // 改变宽
    headerdragend(newWidth, oldWidth, column, event) {
      let Baseno = false;
      this.ObtainHeader.map((item) => {
        if (item.Key == column.property || item.Key == "Number") {
          Baseno = item.BaseNo;
          return;
        }
      });
      if (Baseno != false) {
        let jparams = {
          user_id: tool.getLocal("userid"),
          session_id: tool.getLocal("sessionid"),
          Model: this.$attrs.pargam.Model,
          data: [
            {
              BaseNo: Baseno,
              Width: newWidth,
            },
          ],
        };
        this.request
          .post("/index/Settings/modify_function_fields", {
            jparams: JSON.stringify(jparams),
          })
          .then((res) => {})
          .catch((err) => {
            console.log(err);
          });
      }
    },
    // 根据单据类型查找对应单据
    Nameofbill(val) {
      let pageobj = {};
      pageList.find((tiem) => {
        if (tiem.VchType == val) {
          pageobj = tiem;
        }
      });
      return pageobj;
    },
    //   跳单
    invalidRow(val) {
      console.log(val);
      if (!val.DataPriv.getone) {
        this.$message({
          message: "您没有查看单据权限",
          type: "warning",
        });
        return;
      }
      let vch = this.Nameofbill(val.VchType);
      this.item = {
        component: vch.pageRoute,
        menuId: vch.menuId,
        query: {},
        title: vch.pageName,
      };
      vch.menuId = this.item.menuId + "-1";
      this.$tab.push(this.item, {
        VchCode: val.VchCode,
        VchType: val.VchType,
        type: 1,
        dist: 1
      });
    },
    handleSizeChange(val) {
      this.$emit("handleSizeChange", val);
    },
    handleCurrentChange(val) {
      this.$emit("handleCurrentChange", val);
    },
    sizechange(val){
      this.$emit("sizechange", val);
    },
    // 点击设置
    clickIcon() {
      this.$emit("clickIcon");
    },
    // 点击多选
    changeclick(val, data) {
      //   console.log(val);
      //   console.log(data);
      this.$emit("change", val, data);
    },
    // // 全选
    // changeclicks(val) {
    //   for (let index = 0; index < this.tableData.length; index++) {
    //     const element = this.tableData[index];
    //     element.box = val;
    //   }
    // }
  },
  created() {},
  mounted() {},
  watch: {
    TableDt: {
      handler(newValue, oldValue) {
        setTimeout(() => {
          this.$refs.tableRef.doLayout();
        }, 200);
      },
    },
  },
};
</script>

<style lang="less">
//  .input_box {
// input[type="checkbox"] {
//   width: 14px;
//   height: 14px;
//   display: inline-block;
//   text-align: center;
//   vertical-align: middle;
//   line-height: 14px;
//   position: relative;
// }

// input[type="checkbox"]::before {
//   content: "";
//   position: absolute;
//   top: 0;
//   left: 0;
//   background: #fff;
//   width: 100%;
//   height: 100%;
//   border: 1px solid #d9d9d9;
//   border-radius: 2px;
// }

// input[type="checkbox"]:checked::before {
//   content: "\2713";
//   background-color: #fff;
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   border: 1px solid #409eff;
//   color: #fff;
//   font-size: 14px;
//   font-weight: bold;
//   background-color: #409eff;
// }
// }
.tabone_sty {
  .input_sty {
    background: inherit;
    border: 0;
    outline: 0;
    width: 100%;
    height: 100%;
    display: block;
    box-sizing: border-box;
    padding: 0 10px;
    color: #606266;
  }
}
.input_sty3 {
  height: 34px;
  width: 100%;
  display: block;
  position: relative;
  -webkit-box-flex: 1;
  box-flex: 1;
  padding: 0 !important;
  background: #fff;
  display: block;
  box-sizing: border-box;
  padding: 0 0;
  border: 0; //可根据需要修改有无边框显示长度和宽带
  overflow: hidden;
  // outline: none;
  text-align: center;
}
.el-table .cell {
  padding: 0 !important;
}
.el-table__body td {
  height: 34px;
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Table/Dealings/Dealings.vue